<template>
  <div class="user-list-container">
    <!-- <b-row
      v-if="analytics"
      class="match-height"
    >
      <b-col
        cols="12"
        sm="4"
      >
        <card-statistic
          color="secondary"
          icon="HomeIcon"
          :value="analytics.total"
          title="Tất cả"
        />
      </b-col>
      <b-col
        cols="12"
        sm="4"
      >
        <card-statistic
          icon="HomeIcon"
          :value="analytics.buy"
          title="Đang trả tiền"
          color="secondary"
        />
      </b-col>
      <b-col
        cols="12"
        sm="4"
      >
        <card-statistic
          icon="HomeIcon"
          color="secondary"
          :value="analytics.trial"
          title="Dùng thử"
        />
      </b-col>

    </b-row> -->
    <b-card no-body>
      <b-card-header>
        <b-card-title>Danh sách tài khoản</b-card-title>
        <crud-buttons
          name=" tài khoản"
          modal="modal-user"
          :selected-rows="selectedRows"
          :show-import="$can('create', 'user')"
          :show-export="$can('read', 'user')"
          :enable-add="$can('create', 'user')"
          :hide-delete="!$can('delete', 'user')"
          @on-delete="onDelete"
          @on-add="resetItem"
          @on-import-file="importData"
          @on-export="exportData"
        />
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col>
            <b-form-input
              v-model="searchTerm"
              placeholder="Tìm kiếm tài khoản..."
              debounce="1000"
            />
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col cols="12">
            <vue-good-table
              style-class="vgt-table striped bordered"
              mode="remote"
              :total-rows="totalRecords"
              :is-loading.sync="isLoading"
              :columns="columns"
              :rows="rows"
              :search-options="{
                enabled: false,
              }"
              :pagination-options="{
                enabled: true,
                perPage: serverParams.perPage,
              }"
              @on-selected-rows-change="selectionChanged"
              @on-page-change="onPageChange"
              @on-sort-change="onSortChange"
              @on-column-filter="onColumnFilter"
              @on-per-page-change="onPerPageChange"
            >
              <template slot="loadingContent">
                <b-spinner
                  label="Loading"
                  type="grow"
                />
              </template>
              <template
                slot="table-row"
                slot-scope="props"
              >
                <!-- Column: Code -->
                <span v-if="props.column.field === 'code'">
                  <b-link
                    v-b-modal.modal-user-detail
                    class="font-weight-bold"
                    @click="onEditItem(props.row)"
                  >
                    {{ props.row.code }}
                  </b-link>
                </span>
                <span v-else-if="props.column.field === 'lastLogin'">
                  {{ parseDateToString(props.row.lastLogin, 'DD-MM-YYYY HH:mm') }}
                </span>
                <span v-else-if="props.column.field === 'created_at'">
                  {{ parseDateToString(props.row.created_at, 'DD-MM-YYYY HH:mm') }}
                </span>
                <span v-else-if="props.column.field === 'expiredIn'">
                  {{ parseDateToString(props.row.expiredIn, 'DD-MM-YYYY HH:mm') }}
                </span>
                <span v-else-if="props.column.field === 'active'">
                  <b-badge
                    :variant="props.row.active ? 'light-primary' : 'light-danger'"
                    class="font-small-1"
                  >
                    <span>{{ props.row.active ? "Có" : "Không" }}</span>
                  </b-badge>
                </span>

                <!-- Column: Action -->
                <span v-else-if="props.column.field === 'action'">
                  <table-actions
                    name="người dùng"
                    modal="modal-user"
                    :hide-edit="false"
                    :hide-delete="true"
                    @on-edit="onEditItem(props.row)"
                    @on-delete="onDelete(props.row)"
                  >
                    <template slot="other-buttons">
                      <b-button
                        v-b-tooltip.hover.v-danger
                        v-b-modal.modal-change-user-password
                        variant="danger"
                        class="btn-icon mr-50"
                        size="sm"
                        title="Đổi mật khẩu"
                        @click="onEditItem(props.row)"
                      >
                        <feather-icon icon="LockIcon" />
                      </b-button>

                    </template>
                  </table-actions>
                </span>

                <!-- Column: Common -->
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>

              <!-- pagination -->
              <template
                slot="pagination-bottom"
                slot-scope="props"
              >
                <div class="d-flex justify-content-between flex-wrap">
                  <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> Hiển thị tối đa </span>
                    <b-form-select
                      v-model="serverParams.perPage"
                      :options="['10', '20', '50', '100', '500']"
                      class="mx-1"
                      @input="
                        (value) =>
                          props.perPageChanged({ currentPerPage: value })
                      "
                    />
                    <span class="text-nowrap">
                      trên tổng số {{ props.total }} kết quả
                    </span>
                  </div>
                  <div>
                    <b-pagination
                      :value="1"
                      :total-rows="props.total"
                      :per-page="serverParams.perPage"
                      first-number
                      last-number
                      align="right"
                      prev-class="prev-item"
                      next-class="next-item"
                      class="mt-1 mb-0"
                      @input="
                        (value) => props.pageChanged({ currentPage: value })
                      "
                    >
                      <template #prev-text>
                        <feather-icon
                          icon="ChevronLeftIcon"
                          size="18"
                        />
                      </template>
                      <template #next-text>
                        <feather-icon
                          icon="ChevronRightIcon"
                          size="18"
                        />
                      </template>
                    </b-pagination>
                  </div>
                </div>
              </template>
              <div slot="emptystate">
                <div class="text-center text-muted">
                  Không có bản ghi nào!
                </div>
              </div>
            </vue-good-table>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <user-modal
      :item="item"
      @refetch-data="fetchData"
    />
    <user-detail-modal :user-id="item.id" />
    <change-user-password-modal :item="item" />
  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BLink,
  BPagination,
  BFormSelect,
  BSpinner,
  BBadge,
  BButton,
  VBTooltip,
  VBModal,
} from "bootstrap-vue";

import { VueGoodTable } from "vue-good-table";
import TableActions from "@/views/components/TableActions.vue";
import CrudButtons from "@/views/components/CrudButtons.vue";
// eslint-disable-next-line import/no-cycle
// eslint-disable-next-line import/no-cycle
import { parseDateToString } from '@/auth/utils';
import useUserList from "./useUserList";
import UserModal from "../modal/UserModal.vue";
import UserDetailModal from "../detail/UserDetailModal.vue";
import ChangeUserPasswordModal from '../change-password/ChangeUserPasswordModal.vue';

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BLink,
    BPagination,
    BFormSelect,
    BSpinner,
    BBadge,
    TableActions,
    CrudButtons,
    BButton,
    VueGoodTable,
    UserModal,
    UserDetailModal,
    ChangeUserPasswordModal,
  },
  directives: {
    'b-modal': VBModal,
    "b-tooltip": VBTooltip,
  },
  setup() {
    const {
      analytics,
      item,
      columns,
      rows,
      active,
      selectedRows,
      searchTerm,
      isLoading,
      totalRecords,
      serverParams,

      fetchData,
      fetchUsers,
      deleteUsers,
      onEditItem,
      resetItem,
      updateParams,
      onPageChange,
      onPerPageChange,
      onSortChange,
      onColumnFilter,
      selectionChanged,
      importData,
      exportData,
      syncDataFromItro,
    } = useUserList();

    return {
      analytics,
      item,
      columns,
      rows,
      active,
      selectedRows,
      searchTerm,
      isLoading,
      totalRecords,
      serverParams,

      fetchData,
      fetchUsers,
      deleteUsers,
      onEditItem,
      resetItem,
      updateParams,
      onPageChange,
      onPerPageChange,
      onSortChange,
      onColumnFilter,
      selectionChanged,
      importData,
      exportData,
      parseDateToString,
      syncDataFromItro,
    };
  },

  created() {
    this.fetchData();
  },

  methods: {
    onDelete(user) {
      const deleteObjects = user && user.id > 0 ? [user] : this.selectedRows;
      this.deleteUsers(deleteObjects);
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";

</style>
./useUserList
